import React from "react";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
const TutorialWindow = (props) => {
  const {
    open,
    onClose,
    modalPosition,
    message,
    currentStep,
    screenId,
    reference,
    arrowPosition,
    backgroundColor,
    textColor,
    onSkip,
    skipButtonShow,
  } = props;
  const { t } = useTranslation();
  const handleButton1Click = () => {
    // Handle button 1 click action
  };

  const handleButton2Click = () => {
    // Handle button 2 click action
  };

  const handleButton3Click = () => {
    // Handle button 3 click action
  };
  return (
    <Box
      ref={reference}
      id={screenId}
      sx={{
        backgroundColor: backgroundColor ? backgroundColor : "#444561",
        position: "absolute",
        top: modalPosition?.top,
        left: modalPosition?.left,
         p: 2,
        outline: "none",
        boxShadow: 4,
        zIndex: "9999999",
        maxWidth: "25rem",
        borderRadius: "0.5rem",
        visibility: open ? "visible" : "hidden",
        
      }}
    >
      <Box
        position="relative"
        className={`container container-${arrowPosition}`}
        {...props}
      >
        <Typography
          variant="p"
          color={textColor ? textColor : "#FFFFFF"}
          sx={{
            fontSize: "13px",
          }}
        >
          <p
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          ></p>
        </Typography>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1.5rem",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              flex: 1,
            }}
            variant="p"
            color={textColor ? textColor : "#FFFFFF"}
          >
            {currentStep}/4
          </Typography>
          <Typography
            onClick={() => {
              onClose(currentStep);
            }}
            variant="p"
            color={textColor ? textColor : "#FFFFFF"}
            sx={{
              fontWeight: "bold",
              cursor: "pointer",
              flex: 1,
              textAlign: "center",
            }}
          >
            {t("ft-tutorials.got-it-button")}
          </Typography>
          <Typography
            onClick={() => {
              onSkip();
            }}
            variant="p"
            color={textColor ? textColor : "#FFFFFF"}
            sx={{
              cursor: "pointer",
              visibility: skipButtonShow ? "visible" : "hidden",
              flex: 1,
            }}
          >
            {t("ft-tutorials.skip-button")}
          </Typography>
        </div>
      </Box>
    </Box>
  );
};

export default TutorialWindow;
